import { render, staticRenderFns } from "./iM.vue?vue&type=template&id=f8f05f4a&"
import script from "./iM.vue?vue&type=script&lang=js&"
export * from "./iM.vue?vue&type=script&lang=js&"
import style0 from "./iM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports